import { render, staticRenderFns } from "./MpModel3d.vue?vue&type=template&id=ce617e32&scoped=true&"
import script from "./MpModel3d.vue?vue&type=script&lang=js&"
export * from "./MpModel3d.vue?vue&type=script&lang=js&"
import style0 from "./MpModel3d.vue?vue&type=style&index=0&id=ce617e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce617e32",
  null
  
)

export default component.exports